module.exports = __webpack_public_path__ + "img/music-work-icon13.2faa70fc.png";